// extracted by mini-css-extract-plugin
export default {"menuBlock":"tI-z","title":"uI-z","nav":"vI-z","flexCell":"wI-z","facetLink":"xI-z"};